import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-organization-chooser',
    templateUrl: './organization-chooser.component.html',
    styleUrls: ['./organization-chooser.component.scss'],
})
export class OrganizationChooserComponent implements OnInit {
    @Input() organizations;
    //TODO this should not be the list or organizations

    //TODO create a form control for organization
    //TODO create a formGroup called my form

    //TODO add an output for when a value is selected

    constructor(public activeModal: NgbActiveModal) {}

    ngOnInit() {
        // TODO listen for value changes with the formcontrol with a debounce of 500ms
        // Dispatch the value/search term from teh form control and the @INPUT params
        // Listen for this action in an effect and call the API - only return 5 at a time
        // Update a reducer called userOrganizations in the accounts feature store
        //TODO assign store state to a local variable which will be a list which will then display the list of orgs a user can select,
    }

    organizationSelected(organizationIndex) {
        this.activeModal.dismiss(organizationIndex);
    }
}
